import { render, staticRenderFns } from "./details.vue?vue&type=template&id=78890d3c&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=78890d3c&prod&lang=less"
import style1 from "./details.vue?vue&type=style&index=1&id=78890d3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78890d3c",
  null
  
)

export default component.exports